module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.closeModal === true) ? _c('modal', {
    attrs: {
      "title": "Clôturer  une tournée"
    },
    on: {
      "close": _vm.doCloseAnyModals
    }
  }, [_c('tournees-close', {
    attrs: {
      "slot": "body",
      "tournee": _vm.tournee
    },
    on: {
      "close": _vm.doCloseAnyModals
    },
    slot: "body"
  })], 1) : _vm._e(), _vm._v(" "), _c('tournees-list', {
    on: {
      "close": _vm.clickClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-255cc100!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/tournees/Tournees.vue
// module id = 2093
// module chunks = 2